
import 'pages/persons/persons-list.tag'
import 'pages/persons/person-edit.tag'
import 'pages/persons/companies-list.tag'
import 'pages/persons/company-edit.tag'
import 'pages/persons/accounts-list.tag'
import 'pages/persons/persons-categories-list.tag'
riot.tag2('persons', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="{active: name == tab}" each="{tabs}"><a href="#persons/{link}"><span>{title}</span></a></li>\n  </ul>\n  <div class="column" if="{!notFound}">\n    <persons-list if="{tab == &quot;contacts&quot; &amp;&amp; !edit}"></persons-list>\n    <person-edit if="{tab == &quot;contacts&quot; &amp;&amp; edit}"></person-edit>\n    <companies-list if="{tab == &quot;companies&quot; &amp;&amp; !edit}"></companies-list>\n    <company-edit if="{tab == &quot;companies&quot; &amp;&amp; edit}"></company-edit>\n    <persons-categories-list if="{tab == &quot;categories&quot; &amp;&amp; !edit}"></persons-categories-list>\n    <accounts-list if="{tab == &quot;accounts&quot; &amp;&amp; !edit}"></accounts-list>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.edit = false;

self.tab = '';

self.tabs = [{ title: 'Контакты', name: 'contacts', link: '' }, { title: 'Компании', name: 'companies', link: 'companies' }, { title: 'Группы', name: 'categories', link: 'categories' }, { title: 'Операции по счетам', name: 'accounts', link: 'accounts' }];

route('/persons', function () {
    self.edit = false;
    self.tab = 'contacts';
    self.update();
});

route('/persons/([0-9]+)', function (id) {
    self.tab = 'contacts';
    observable.trigger('persons-edit', id);
    self.edit = true;
    self.update();
});

route('/persons/*', function (tab) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: false, tab: tab });
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/persons/*/([0-9]+)', function (tab, id) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: true, tab: tab });
        observable.trigger(tab + '-edit', id);
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/persons/companies/new', function (tab) {
    self.update({ edit: true, tab: 'companies' });
    observable.trigger('companies-new');
});

route('/persons..', function () {
    self.update({ edit: true, tab: 'not-found' });
    observable.trigger('not-found');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/persons/persons.tag